import { type InsuranceCorporateIdentity } from "../types";

export function BKKFreudenbergLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M64 198.75H76.3224V181.743H94.3376L94.2655 173.168H76.3224V162.792H95.6347V154.144H64V198.75Z"
        fill="white"
      />
      <path
        d="M99.7416 198.75H111.343V185.563C111.343 182.176 112.352 177.131 119.414 177.131C120.207 177.131 120.567 177.204 121.864 177.348V167.403C119.198 167.331 113.577 167.187 110.983 174.033L110.767 167.619H99.4534L99.7416 174.177V198.75Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.598 185.563C156.598 180.086 156.166 177.132 154.869 174.465C152.779 170.07 148.744 166.539 140.096 166.539C128.639 166.539 123.522 173.312 123.595 183.689C123.522 193.994 129.359 199.398 140.168 199.398C148.239 199.398 155.517 196.372 156.382 188.589H145.501C145.213 191.544 143.267 193.129 140.168 193.129C134.259 193.129 134.187 187.22 134.259 185.635H156.598V185.563ZM134.476 179.221C134.62 177.708 134.98 172.736 140.096 172.736C145.141 172.736 145.501 177.42 145.645 179.293L134.476 179.221Z"
        fill="white"
      />
      <path
        d="M161.282 167.692V185.202C161.282 191.111 162.003 199.254 172.74 199.254C175.478 199.254 179.441 198.894 182.54 193.85L182.828 198.678L194.214 198.75C194.214 196.3 194.142 196.011 194.07 193.345V167.692H182.468V185.707C182.54 187.364 182.468 191.832 177.568 191.832C172.884 191.832 172.956 187.58 172.884 185.779V167.692H161.282Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.389 154.072V171.367C220.371 169.205 218.137 167.043 212.949 167.043C209.058 167.043 205.599 168.196 202.789 171.222C200.699 173.6 198.897 176.627 198.825 183.257C198.897 190.895 201.852 199.542 212.589 199.542C219.435 199.542 221.885 196.011 223.11 194.21L223.326 198.822L234.351 198.75C234.207 196.155 234.063 193.633 234.063 191.039V154.144L222.389 154.072ZM216.696 192.624C211.58 192.624 210.931 186.283 210.931 183.257C210.931 180.302 211.508 173.745 216.84 173.817C220.948 173.817 222.605 177.924 222.605 183.112C222.605 188.373 220.876 192.624 216.696 192.624Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.31 185.563C270.31 180.086 269.877 177.132 268.58 174.465C266.49 170.07 262.455 166.539 253.808 166.539C242.35 166.539 237.306 173.312 237.378 183.689C237.378 193.994 243.143 199.398 253.952 199.398C262.023 199.47 269.301 196.372 270.166 188.589H259.284C258.996 191.544 257.051 193.129 253.952 193.129C248.043 193.129 248.043 187.22 248.043 185.635H270.31V185.563ZM248.187 179.221C248.331 177.708 248.691 172.736 253.808 172.736C258.852 172.736 259.212 177.42 259.429 179.221H248.187Z"
        fill="white"
      />
      <path
        d="M274.345 198.75L285.875 198.678L285.947 180.879C285.947 179.798 285.947 174.321 291.135 174.321C295.963 174.321 295.891 178.717 295.963 180.879V198.75L307.565 198.678L307.637 179.942C307.637 175.618 307.565 167.043 296.179 166.971C289.694 166.971 287.244 170.07 285.875 172.375L285.73 167.619H274.129L274.417 174.249L274.345 198.75Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M313.042 154.072V190.967C313.042 191.111 312.97 195.219 312.609 198.678H323.491L323.851 194.066C327.742 199.182 332.21 199.326 334.228 199.326C336.606 199.326 340.497 198.966 343.956 195.219C346.55 192.408 347.991 189.021 347.991 182.968C347.991 179.582 347.703 176.195 346.046 173.312C344.1 169.997 340.497 166.827 334.516 166.827C333.363 166.827 327.886 166.899 324.716 170.862V154L313.042 154.072ZM324.355 182.968C324.283 180.662 324.644 173.528 330.48 173.528C335.669 173.528 336.029 179.726 336.029 182.824C336.029 184.914 336.101 192.336 330.192 192.336C324.716 192.408 324.283 185.058 324.355 182.968Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M384.67 185.563C384.67 180.086 384.31 177.132 382.869 174.465C380.851 170.07 376.815 166.539 368.096 166.539C356.639 166.539 351.594 173.24 351.594 183.689C351.594 193.994 357.431 199.398 368.24 199.398C376.311 199.47 383.589 196.372 384.454 188.589H373.573C373.285 191.472 371.339 193.057 368.24 193.129C362.331 193.129 362.331 187.22 362.331 185.563H384.67ZM362.475 179.221C362.62 177.708 362.98 172.736 368.096 172.736C373.14 172.736 373.573 177.42 373.645 179.149L362.475 179.221Z"
        fill="white"
      />
      <path
        d="M388.849 198.678L400.379 198.75V185.563C400.451 182.176 401.388 177.203 408.45 177.203C409.315 177.203 409.603 177.276 410.972 177.42V167.475C408.306 167.403 402.685 167.259 400.019 174.177L399.875 167.764H388.561L388.921 174.321L388.849 198.678Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M438.067 167.475V172.159C436.482 169.709 433.887 166.971 427.762 166.971C418.322 166.971 413.854 173.961 413.854 182.392C413.854 193.705 421.061 197.813 427.618 197.813C429.42 197.813 434.464 197.525 437.635 192.769V196.876C437.635 200.191 437.274 204.443 431.437 204.443C428.122 204.443 426.393 202.785 426.321 200.479H415.368C415.44 202.065 415.512 204.947 418.25 207.397C421.781 210.568 427.618 211 431.149 211C437.562 211 441.31 209.487 443.976 207.541C448.155 204.515 448.948 200.191 448.948 196.444V167.475H438.067ZM437.49 182.104C437.49 184.266 437.346 190.895 431.726 190.895C426.609 190.895 425.889 185.491 425.817 182.248C425.889 177.132 427.906 173.456 431.87 173.528C437.49 173.384 437.49 180.446 437.49 182.104Z"
        fill="white"
      />
      <path
        d="M303.809 377.618H376.618V450.427H303.809V377.618Z"
        fill="#FFC900"
      />
      <path
        d="M303.809 304.809L231 232.136H303.605L376.618 304.809H303.809Z"
        fill="#FFC900"
      />
      <path
        d="M449.495 304.809L376.618 377.618V304.809L449.427 232L449.495 304.809Z"
        fill="#FFC900"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M367.636 334.001C371.378 334.001 374.44 330.939 374.44 327.264C374.44 323.522 371.378 320.528 367.704 320.528C364.03 320.528 360.899 323.522 360.899 327.264C360.899 331.007 363.961 334.069 367.636 334.001ZM367.636 332.98C364.37 332.912 361.988 330.598 361.988 327.264C361.988 323.998 364.37 321.684 367.704 321.616C370.97 321.616 373.352 323.998 373.352 327.264C373.352 330.598 370.97 332.98 367.636 332.98ZM366.071 327.672H367.772L369.949 331.075H371.038L368.725 327.604C370.086 327.536 371.106 326.992 371.106 325.495C371.106 324.066 370.426 323.385 368.452 323.385H365.118V331.075H366.071V327.672ZM366.071 326.788V324.338H368.248C369.133 324.338 370.086 324.474 370.018 325.495C370.086 326.992 368.521 326.788 367.432 326.788H366.071Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M235.423 362.24H253.864C257.538 362.172 261.757 362.172 265.023 360.47C269.582 358.089 270.807 354.278 270.807 351.012C270.875 342.506 263.322 341.145 260.804 340.669L260.736 340.601C262.846 340.057 269.65 338.492 269.65 331.143C269.65 327.468 267.813 325.155 266.52 323.998C262.709 320.596 257.334 320.596 252.094 320.596H235.423V362.24ZM246.651 328.149H252.911C254.136 328.149 255.361 328.149 256.653 329.169C257.81 330.054 258.286 331.619 258.218 332.844C258.218 334.613 257.402 336.11 256.041 336.927C255.088 337.403 253.864 337.403 252.026 337.403H246.651V328.149ZM246.719 344.752H252.775C254.34 344.752 259.035 344.752 259.035 349.719C259.035 354.55 254.408 354.55 253.115 354.55H246.719V344.752Z"
        fill="white"
      />
      <path
        d="M278.292 362.24L289.996 362.172V340.057L303.809 362.172L318.099 362.24L302.584 338.9L316.942 320.596H303.265L289.996 338.9V320.596H278.292V362.24Z"
        fill="white"
      />
      <path
        d="M323.474 362.24H335.178V340.125L348.992 362.24L363.281 362.172L347.767 338.9L362.124 320.596H348.515L335.178 338.9V320.596H323.474V362.24Z"
        fill="white"
      />
      {/* Additional complex path elements - truncated for brevity */}
    </svg>
  );
}

export const BKKFreudenberg: InsuranceCorporateIdentity = {
  id: "bkk-freudenberg",
  name: "BKK Freudenberg",
  logo: BKKFreudenbergLogo,
  backgroundColor: "#1668AF",
  textColor: "#FFFFFF",
  wildcard: "bkk freudenberg",
  type: "statutory",
};
